import { Button } from "@/components/ui/button";
import { Building, ShoppingCart } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export function Hero() {
	const [scrollPosition, setScrollPosition] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			const position = window.scrollY;
			setScrollPosition(position);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	// Calculate parallax effect
	const imageTranslate = scrollPosition * 0.1;
	const titleOpacity = Math.max(1 - scrollPosition * 0.005, 0);
	const titleTranslate = scrollPosition * 0.3;

	return (
		<section className="relative overflow-hidden pt-20 md:pt-30">
			{/* Background elements */}
			<div className="absolute inset-0 z-0">
				<div
					className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1601599963565-b7f49deb352a?q=80&w=3164&auto=format&fit=crop')] bg-cover bg-center bg-no-repeat"
					style={{
						opacity: 0.08,
						transform: `translateY(${imageTranslate}px)`,
					}}
				/>
				<div className="absolute inset-0 bg-gradient-to-b from-white via-white/95 to-white" />
			</div>

			{/* Content */}
			<div className="container relative z-10 max-w-6xl mx-auto px-10 md:px-10">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
					<div className="flex flex-col items-center md:items-start text-center md:text-left">
						<div
							className="transition-all duration-300 ease-out"
							style={{
								opacity: titleOpacity,
								transform: `translateY(-${titleTranslate}px)`,
							}}>
							<span className="inline-block mb-5 px-3 py-1 text-xs font-medium tracking-wider text-gray-700 uppercase bg-gray-100 rounded-full">
								Food & Beverage Wholesale Marketplace
							</span>

							<h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-semibold tracking-tight leading-tight text-gray-900 mb-6 text-balance">
								F&B Wholesale made easy
							</h1>

							<p className="max-w-2xl md:max-w-none text-lg md:text-xl text-gray-600 mb-10">
								Connecting independent brands directly with
								retailers <br />
								Welcome seamless ordering and lower commissions.
							</p>

							<div className="flex flex-col sm:flex-row items-center md:items-start justify-center md:justify-start gap-5">
								<Link to="/auth?signup=true&seller=true">
									<Button
										size="lg"
										variant="accent"
										className="gap-2 px-8 py-6 text-base w-full sm:w-auto">
										<ShoppingCart className="h-4 w-4" />
										Shop Wholesale
									</Button>
								</Link>
								<Link to="/auth?signup=true&seller=true">
									<Button
										variant="outline"
										size="lg"
										className="gap-2 px-8 py-6 text-base border-gray-200 text-gray-700 hover:bg-gray-50 w-full sm:w-auto">
										<Building className="h-4 w-4" />
										Sell Your Products
									</Button>
								</Link>
							</div>
						</div>
					</div>

					<div
						className="hidden md:block"
						style={{
							opacity: titleOpacity,
							transform: `translateY(-${titleTranslate}px)`,
						}}>
						<img
							src="/images/hero-bg.jpg"
							alt="Indoor marketplace with vendors and customers"
							className="rounded-2xl w-full h-auto object-cover shadow-2xl"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
